import { RecordsResponse } from "@services/http/responses/BaseResponse";
import useApiRequests from "@services/http/useApiRequest";
import { GetLocationsRequest, ILocationForList } from "@services/locations";
import { RootState } from "@store";
import { setLocations } from "@store/locations/actions";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

type LocationsUpdater = () => Promise<void>;

export const locationsCacheKey = "24p9gjwerogneprgi30gjg45gijqiq";
export const useLocationsUpdater = (cb?: any): LocationsUpdater => {
  const requests = useApiRequests();
  const dispatch = useDispatch();
  const initialized = useSelector(
    (state: RootState) => state.locations.initialized
  );
  return useCallback(async () => {
    if (initialized) return;
    // let locs = loadCache<ILocationForList[]>(locationsCacheKey);
    // if (!locs) {
    const response = await requests.enqueue<RecordsResponse<ILocationForList>>(
      new GetLocationsRequest(),
      { onLoadingStatusChanged: cb }
    );
    if (!response) return;
    dispatch(setLocations(response.Records));
    // saveCache(locationsCacheKey, locs, 10 * MINUTE);
    // }
    // dispatch(setLocations(locs));
  }, [requests, dispatch, initialized]);
};

